/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Toast_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not update the integration. Please try again." |
*
* @param {Integrations_Toast_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_toast_error = /** @type {((inputs?: Integrations_Toast_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Toast_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Integration konnte nicht aktualisiert werden. Bitte erneut versuchen.")
	return /** @type {LocalizedString} */ ("Could not update the integration. Please try again.")
});